import { isServerSupported } from 'utils/predicates';

import { baseUrl } from './constants';

const getImageUrl = (image: string) =>
  isServerSupported() ? `${baseUrl}/storage?file=${image}` : image;

export default getImageUrl;
